import { render, staticRenderFns } from "./CmsDetails.vue?vue&type=template&id=4417b4ae&scoped=true&"
import script from "./CmsDetails.vue?vue&type=script&lang=js&"
export * from "./CmsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CmsDetails.vue?vue&type=style&index=0&id=4417b4ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4417b4ae",
  null
  
)

export default component.exports